import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {CdoDocumentRequest} from '../../interfaces/customer-documents/cdo-document-request';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdoDocumentRequestFactory} from '../../factories/customer-documents/cdo-document-request-factory';

@Injectable({
  providedIn: 'root'
})
export class CdoDocumentRequestsTable extends SecureTable<CdoDocumentRequest> {

  public constructor() {
    super(db.cdoDocumentRequests);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<CdoDocumentRequest>({
        api: ['cdo-document-requests'],
        fromObject: CdoDocumentRequestFactory.fromObject,
        toRemote: CdoDocumentRequestFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CdoDocumentRequest[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   * Drops the already synchronized requests of the given customers, so the
   * server answer can replace them. Requests fulfilled in the meantime are not
   * returned by the server and therefore disappear here as well.
   *
   * @param customerIds
   */
  public async removeSyncedByCustomerIds(customerIds: number[]): Promise<void> {
    const cdoDocumentRequests = await this.table.where('customerId').anyOf(customerIds).toArray();
    await this.removeMany(cdoDocumentRequests.map(({ uuid }) => uuid), true);
  }

}
